export const WORKERS_IMPORT_CONFIG = {
  entityName: 'Workers',
  apiEndpoint: '/workers/import',
  listPath: 'workers',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Configuration' }, { label: 'Workers', link: 'workers' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'employee_code', label: 'Employee Code', required: true, autoMatch: ['employee_code', 'employee*code'] },
    { key: 'name', label: 'Name', required: true, autoMatch: ['name'] },
    { key: 'position_name', label: 'Position Name (create only)', required: false, autoMatch: ['position_name', 'position'] },
    { key: 'department_work_center', label: 'Department (Code or Name — create only)', required: false, autoMatch: ['department', 'work*center'] },
    { key: 'hire_date', label: 'Hire Date', required: false, isDateField: true, autoMatch: ['hire_date', 'hire*date'] },
    { key: 'termination_date', label: 'Exit Date (update only)', required: false, isDateField: true, autoMatch: ['exit_date', 'exit*date', 'termination_date', 'termination*date'] },
    { key: 'hiring_remarks', label: 'Hiring Remarks', required: false, autoMatch: ['hiring_remarks', 'hiring*remarks'] },
    { key: 'termination_remarks', label: 'Exit Remarks (update only)', required: false, autoMatch: ['exit_remarks', 'exit*remarks', 'termination_remarks'] },
    { key: 'status', label: 'Status (update only)', required: false, autoMatch: ['status'] },
    { key: 'wage_type', label: 'Wage Type (piece_rate / fixed / piece_rate_with_minimum — create only)', required: false, autoMatch: ['wage_type', 'wage*type'] },
    { key: 'fixed_wage_sub_type', label: 'Fixed Wage Sub-type (hourly / daily / monthly — create only)', required: false, autoMatch: ['fixed_wage_sub_type', 'sub*type', 'pay*frequency', 'frequency'] },
    { key: 'hourly_rate', label: 'Hourly Rate (create only)', required: false, autoMatch: ['hourly_rate', 'hourly*rate'] },
    { key: 'daily_rate', label: 'Daily Rate (create only)', required: false, autoMatch: ['daily_rate', 'daily*rate'] },
    { key: 'monthly_rate', label: 'Monthly Rate (create only)', required: false, autoMatch: ['monthly_rate', 'monthly*rate'] },
    { key: 'shifts', label: 'Shifts (names, comma-separated — create only, use worker edit to change on existing workers)', required: false, autoMatch: ['shifts', 'shift'] },
  ],
  transformMapping: (mapping) => {
    const { department_work_center, ...rest } = mapping;
    return {
      ...rest,
      department_work_center_code: department_work_center || '',
      department_work_center_name: '',
    };
  },
};

export const WORK_ORDERS_IMPORT_CONFIG = {
  entityName: 'Work Orders',
  apiEndpoint: '/work-orders/import',
  listPath: 'work-orders',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Production' }, { label: 'Work Orders', link: 'work-orders' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'work_order_code', label: 'Work Order Code', required: true, autoMatch: ['work_order_code', 'work*order*code', 'code'] },
    { key: 'name', label: 'Name', required: false, autoMatch: ['name'] },
    { key: 'description', label: 'Description', required: false, autoMatch: ['description'] },
    { key: 'expected_production_qty', label: 'Expected Production Qty', required: false, autoMatch: ['expected_production_qty', 'expected*qty', 'quantity'] },
    { key: 'status', label: 'Status (create only — use the Transition action to change status on an existing work order)', required: false, autoMatch: ['status'] },
    { key: 'work_group_code', label: 'Work Group Code', required: false, autoMatch: ['work_group_code', 'work*group*code', 'group*code'] },
    { key: 'target_start_date', label: 'Target Start Date', required: false, isDateField: true, autoMatch: ['target_start_date', 'start*date'] },
    { key: 'target_completion_date', label: 'Target Completion Date', required: false, isDateField: true, autoMatch: ['target_completion_date', 'completion*date', 'target*date'] },
    { key: 'confirmed_date', label: 'Confirmed Date', required: false, isDateField: true, autoMatch: ['confirmed_date', 'confirm*date'] },
  ],
};

export const INVENTORY_IMPORT_CONFIG = {
  entityName: 'Inventory Movements',
  apiEndpoint: '/inventory/import',
  listPath: 'inventory',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Production' }, { label: 'Inventory', link: 'inventory' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'date', label: 'Date', required: true, isDateField: true, autoMatch: ['date'] },
    { key: 'work_order_code', label: 'Work Order Code', required: true, autoMatch: ['work_order_code', 'work*order*code'] },
    { key: 'from_work_center_code', label: 'From Work Center Code', required: false, autoMatch: ['from_work_center_code', 'from*work*center', 'from*center'] },
    { key: 'to_work_center_code', label: 'To Work Center Code', required: false, autoMatch: ['to_work_center_code', 'to*work*center', 'to*center'] },
    { key: 'quantity', label: 'Quantity', required: true, autoMatch: ['quantity', 'qty'] },
    { key: 'transfer_type', label: 'Transfer Type', required: false, autoMatch: ['transfer_type', 'type'] },
    { key: 'reference_number', label: 'Reference Number', required: false, autoMatch: ['reference_number', 'reference', 'ref'] },
    { key: 'notes', label: 'Notes', required: false, autoMatch: ['notes', 'note'] },
  ],
};

export const ATTENDANCE_IMPORT_CONFIG = {
  entityName: 'Attendance',
  apiEndpoint: '/attendance/import',
  listPath: 'attendance',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Production' }, { label: 'Attendance', link: 'attendance' }, { label: 'Import' }],
  columns: [
    { key: 'date', label: 'Date', required: true, isDateField: true, autoMatch: ['date'] },
    { key: 'worker_code', label: 'Worker Code', required: true, autoMatch: ['worker_code', 'employee_code', 'employee*code'] },
    { key: 'status', label: 'Status', required: true, autoMatch: ['status'] },
    { key: 'clock_in', label: 'Clock In', required: false, autoMatch: ['clock_in', 'clock*in', 'in'] },
    { key: 'clock_out', label: 'Clock Out', required: false, autoMatch: ['clock_out', 'clock*out', 'out'] },
  ],
};

export const WORK_LOG_IMPORT_CONFIG = {
  entityName: 'Work Logs',
  apiEndpoint: '/work-log/import',
  listPath: 'work-log',
  dateFormats: 'extended',
  breadcrumbs: [{ label: 'Production' }, { label: 'Work Log', link: 'work-log' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'date', label: 'Date', required: true, isDateField: true, autoMatch: ['date'] },
    { key: 'worker_code', label: 'Worker Code', required: false, autoMatch: ['worker_code', 'employee_code', 'employee*code'] },
    { key: 'work_order_code', label: 'Work Order Code (required unless the operation belongs to only one work center)', required: false, autoMatch: ['work_order_code', 'work*order*code'] },
    { key: 'operation_code', label: 'Operation Code', required: true, autoMatch: ['operation_code', 'operation*code'] },
    { key: 'quantity', label: 'Quantity', required: true, autoMatch: ['quantity', 'qty'] },
    { key: 'ticket_reference', label: 'Ticket Reference', required: false, autoMatch: ['ticket_reference', 'ticket', 'reference'] },
  ],
};

export const QUALITY_INSPECTION_IMPORT_CONFIG = {
  entityName: 'Quality Inspections',
  apiEndpoint: '/quality-inspections/import',
  listPath: 'quality',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Production' }, { label: 'Quality', link: 'quality' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'date', label: 'Date', required: true, isDateField: true, autoMatch: ['date'] },
    { key: 'work_center_code', label: 'Work Center Code', required: true, autoMatch: ['work_center_code', 'work*center*code'] },
    { key: 'work_order_code', label: 'Work Order Code', required: false, autoMatch: ['work_order_code', 'work*order*code'] },
    { key: 'inspector_code', label: 'Inspector Code', required: false, autoMatch: ['inspector_code', 'inspector'] },
    { key: 'qty_inspected', label: 'Qty Inspected', required: true, autoMatch: ['qty_inspected', 'inspected'] },
    { key: 'qty_defective', label: 'Qty Defective', required: true, autoMatch: ['qty_defective', 'defective'] },
    { key: 'defect_reasons', label: 'Defect Reasons', required: false, autoMatch: ['defect_reasons', 'defect*reasons'] },
    { key: 'notes', label: 'Notes', required: false, autoMatch: ['notes', 'note'] },
  ],
};

export const WORK_ORDER_OPERATIONS_IMPORT_CONFIG = {
  entityName: 'Work Order Operations',
  apiEndpoint: '/work-orders/operations/import',
  listPath: 'work-orders',
  dateFormats: null,
  breadcrumbs: [{ label: 'Production' }, { label: 'Work Orders', link: 'work-orders' }, { label: 'Import Operations' }],
  columns: [
    { key: 'work_order_code', label: 'Work Order Code', required: true, autoMatch: ['work_order_code', 'work*order*code', 'wo*code'] },
    { key: 'operation_code', label: 'Operation Code', required: true, autoMatch: ['operation_code', 'op*code', 'operation'] },
  ],
};

export const WORK_GROUPS_IMPORT_CONFIG = {
  entityName: 'Work Groups',
  apiEndpoint: '/work-groups/import',
  listPath: 'work-groups',
  dateFormats: 'standard',
  breadcrumbs: [{ label: 'Masters' }, { label: 'Work Groups', link: 'work-groups' }, { label: 'Import' }],
  columns: [
    { key: 'code', label: 'Code', required: true, autoMatch: ['code'] },
    { key: 'name', label: 'Name', required: false, autoMatch: ['name'] },
    { key: 'description', label: 'Description', required: false, autoMatch: ['description'] },
    { key: 'customer_name', label: 'Customer Name', required: false, autoMatch: ['customer_name', 'customer'] },
    { key: 'status', label: 'Status', required: false, autoMatch: ['status'] },
    { key: 'confirmed_date', label: 'Confirmed Date', required: false, isDateField: true, autoMatch: ['confirmed_date', 'confirm*date'] },
    { key: 'target_start_date', label: 'Target Start Date', required: false, isDateField: true, autoMatch: ['target_start_date', 'start*date'] },
    { key: 'target_completion_date', label: 'Target Completion Date', required: false, isDateField: true, autoMatch: ['target_completion_date', 'completion*date'] },
    { key: 'notes', label: 'Notes', required: false, autoMatch: ['notes', 'note'] },
  ],
};

export const POSITIONS_IMPORT_CONFIG = {
  entityName: 'Positions',
  apiEndpoint: '/workers/positions/import',
  listPath: 'positions',
  dateFormats: null,
  breadcrumbs: [{ label: 'Configuration' }, { label: 'Positions', link: 'positions' }, { label: 'Import' }],
  columns: [
    { key: 'id', label: 'ID (leave blank to create new)', required: false, autoMatch: ['id'] },
    { key: 'name', label: 'Name', required: true, autoMatch: ['name'] },
    { key: 'description', label: 'Description', required: false, autoMatch: ['description'] },
    { key: 'department', label: 'Department (Code or Name)', required: false, autoMatch: ['department'] },
    { key: 'level', label: 'Level', required: false, autoMatch: ['level'] },
  ],
  transformMapping: (mapping) => {
    const { department, ...rest } = mapping;
    return {
      ...rest,
      department_code: department || '',
      department_name: '',
    };
  },
};
